export enum EmailTemplateRouteName {
    Index = 'system.templates.emails.index',
    Create = 'system.templates.emails.create',
    Edit = 'system.templates.emails.edit',
    EditTemplate = 'system.templates.emails.editTemplate',
    Clone = 'system.templates.emails.clone',
    Preview = 'system.templates.emails.preview',
    Send = 'system.templates.emails.send',
}

export default {
    path: 'templates/email',
    name: EmailTemplateRouteName.Index,
    component: () => import('@/views/system/template/email/Index.vue'),
    meta: {
        auth: true,
        label: 'Email Templates',
        icon: 'fal fa-envelope fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-email-templates',
    },
    children: [
        {
            path: 'create',
            name: EmailTemplateRouteName.Create,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Email Template',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
        {
            path: ':emailTemplateId/edit',
            name: EmailTemplateRouteName.Edit,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Email Template',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
        {
            path: ':emailTemplateId/edit-template',
            name: EmailTemplateRouteName.EditTemplate,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Email Template',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
        {
            path: ':emailTemplateId/clone',
            name: EmailTemplateRouteName.Clone,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Clone Email Template',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
        {
            path: ':emailTemplateId/preview',
            name: EmailTemplateRouteName.Preview,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Preview Email Template',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
        {
            path: ':emailTemplateId/send',
            name: EmailTemplateRouteName.Send,
            component: () => import('@/views/system/template/email/Index.vue'),
            meta: {
                auth: true,
                label: 'Send Email',
                icon: 'fal fa-envelope fa-fw',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-email-templates',
            },
        },
    ],
}
